import { Fraction } from 'bi-fraction';
import { calcTokenBPriceOfTokenA } from '../utils/calcTokenBPriceOfTokenA';
import { isAddressEq } from '../utils/isAddressEq';
export class UsdPriceServiceAbstract {
    constructor(baseUsdToken) {
        this.baseUsdToken = baseUsdToken;
        this.calcUSDPrice = async (token) => {
            token = this.toWrappedToken(token);
            const lpAddresses = await this.getLpAddresses(token);
            if (!lpAddresses)
                return;
            return (await Promise.all(lpAddresses.map(async (lp) => {
                const [token0, token1, reserves] = await Promise.all([
                    this.getToken0(lp.address),
                    this.getToken1(lp.address),
                    this.getReserves(lp.address),
                ]);
                return {
                    token0,
                    token1,
                    reserve0: reserves._reserve0.toString(),
                    reserve1: reserves._reserve1.toString(),
                };
            })))
                .map((info, i) => calcTokenBPriceOfTokenA(lpAddresses[i].input, lpAddresses[i].output, info))
                .reduce((a, b) => a.mul(b), new Fraction(1));
        };
        this.getLpAddresses = async (token) => getLpAddresses(token, this.baseUsdToken, await this.getLpPairs());
    }
}
const getLpAddresses = (token, usdToken, lpPairs) => {
    const toUsd = {};
    lpPairs.forEach(({ token, quoteToken, address }) => {
        if (isAddressEq(token.address, usdToken.address))
            toUsd[quoteToken.address.toLowerCase()] = address;
        if (isAddressEq(quoteToken.address, usdToken.address))
            toUsd[token.address.toLowerCase()] = address;
    });
    const address = toUsd[token.address.toLowerCase()];
    if (address)
        return [
            {
                input: token,
                output: usdToken,
                address,
            },
        ];
    for (const lp of lpPairs) {
        let mid;
        if (isAddressEq(lp.token.address, token.address) &&
            toUsd[lp.quoteToken.address.toLowerCase()])
            mid = lp.quoteToken;
        else if (isAddressEq(lp.quoteToken.address, token.address) &&
            toUsd[lp.token.address.toLowerCase()])
            mid = lp.token;
        if (mid !== undefined) {
            const address = toUsd[mid.address.toLowerCase()];
            if (!address)
                continue;
            return [
                {
                    input: token,
                    output: mid,
                    address: lp.address,
                },
                {
                    input: mid,
                    output: usdToken,
                    address,
                },
            ];
        }
    }
};
